import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useReveal } from '../hooks';
import ArrowIcon from '../components/ArrowIcon';
import Footer from '../components/Footer';

const SERVICES = [
  'IoT Product Development',
  'Embedded Hardware Design',
  'Embedded Software / Firmware',
  'PCB Design Services',
  'AI / ML Solutions',
  'Edge Computing',
  'IoT Cloud Integration',
  'PoC to MVP Development',
  'Other / Not sure yet',
];

const OFFICES = [
  { city: 'Bengaluru', tag: 'HQ', street: 'Muddina Palya', country: 'Karnataka, India' },
];

const SOCIALS = [
  { label: 'LinkedIn', href: '#' },
  { label: 'X / Twitter', href: '#' },
  { label: 'GitHub', href: '#' },
  { label: 'Instagram', href: '#' },
];

const SOCIAL_ICONS = {
  LinkedIn: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  ),
  'X / Twitter': (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.742l7.736-8.849L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  ),
  GitHub: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z" />
    </svg>
  ),
  Instagram: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
    </svg>
  ),
};

export default function ContactPage() {
  useReveal();

  const [form, setForm] = useState({ name: '', email: '', company: '', service: '', message: '' });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'Name is required';
    if (!form.email.trim() || !/\S+@\S+\.\S+/.test(form.email)) e.email = 'Valid email required';
    if (!form.message.trim()) e.message = 'Message is required';
    return e;
  };

  const handleChange = field => e => {
    setForm(f => ({ ...f, [field]: e.target.value }));
    if (errors[field]) setErrors(er => ({ ...er, [field]: undefined }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setSending(true);
    const subject = encodeURIComponent(`Zone-X Inquiry — ${form.service || 'General'} — ${form.name}`);
    const body = encodeURIComponent(
      `Name: ${form.name}\nEmail: ${form.email}\nCompany: ${form.company || 'N/A'}\nService: ${form.service || 'Not specified'}\n\n---\n\n${form.message}`
    );
    setTimeout(() => {
      window.location.href = `mailto:trispider777@gmail.com?subject=${subject}&body=${body}`;
      setSending(false);
      setSubmitted(true);
    }, 800);
  };

  return (
    <>
      <Helmet>
        <title>Get In Touch | Zone-X Laboratories</title>
        <meta name="description" content="Contact Zone-X Laboratories for IoT, embedded systems, AI/ML, or full-stack engineering projects. Offices in Bengaluru, Berlin, and New York. Typical response time: 24 hours." />
        <meta property="og:title" content="Get In Touch | Zone-X Laboratories" />
        <meta property="og:description" content="Start your next engineering project with Zone-X. We respond within 24 hours." />
        <meta property="og:url" content="https://zone-x.dev/contact" />
        <link rel="canonical" href="https://zone-x.dev/contact" />
      </Helmet>

      {/* ── HERO ── */}
      <section style={{ padding: '152px 0 56px', position: 'relative' }}>
        <div style={{ maxWidth: 1320, margin: '0 auto', padding: '0 32px' }}>

          {/* Breadcrumb */}
          <div className="reveal" style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 40 }}>
            <Link
              to="/"
              style={{ fontSize: 12, fontWeight: 600, letterSpacing: '0.04em', textTransform: 'uppercase', color: 'var(--ink-soft)', transition: 'color 200ms ease' }}
              onMouseEnter={e => { e.currentTarget.style.color = 'var(--red)'; }}
              onMouseLeave={e => { e.currentTarget.style.color = 'var(--ink-soft)'; }}
            >
              Home
            </Link>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{ opacity: 0.3, flexShrink: 0 }}>
              <path d="M5 3l4 4-4 4" stroke="var(--ink)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span style={{ fontSize: 12, fontWeight: 600, letterSpacing: '0.04em', textTransform: 'uppercase', color: 'var(--blue)' }}>Contact</span>
          </div>

          {/* Tag */}
          <div className="reveal" style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 28 }}>
            <span style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: 10, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase',
              color: 'var(--blue)', padding: '5px 14px',
              background: 'rgba(0,60,255,0.06)',
              border: '1px solid rgba(0,60,255,0.18)',
              borderRadius: 999,
            }}>
              Let's Talk
            </span>
            <div style={{ width: 48, height: 1, background: 'var(--blue)', opacity: 0.25 }} />
          </div>

          {/* Heading */}
          <h1
            className="reveal"
            style={{
              fontFamily: "'Anton', sans-serif",
              fontWeight: 400,
              fontSize: 'clamp(52px, 8vw, 100px)',
              lineHeight: 0.92,
              color: 'var(--ink)',
              marginBottom: 28,
              maxWidth: 800,
            }}
          >
            GET IN<br />
            <span style={{ color: 'var(--blue)' }}>TOUCH.</span>
          </h1>

          <p className="reveal" style={{ fontSize: 18, lineHeight: 1.75, color: 'var(--ink-soft)', maxWidth: 520 }}>
            Have a project in mind? Describe what you're building and we'll get back to you within 24 hours.
          </p>
        </div>
      </section>

      {/* ── FORM + INFO ── */}
      <section style={{ padding: '32px 0 120px' }}>
        <div style={{ maxWidth: 1320, margin: '0 auto', padding: '0 32px' }}>
          <div
            className="contact-page-grid"
            style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1.55fr) minmax(0, 1fr)', gap: 24, alignItems: 'start' }}
          >
            {/* ── Form Card ── */}
            <div
              className="reveal"
              style={{
                background: 'linear-gradient(135deg, rgba(255,255,255,0.75), rgba(255,255,255,0.42))',
                border: '1px solid var(--line)',
                borderRadius: 28,
                padding: 'clamp(28px, 4vw, 52px)',
                backdropFilter: 'blur(20px)',
                WebkitBackdropFilter: 'blur(20px)',
              }}
            >
              {submitted ? (
                <SuccessState name={form.name} onReset={() => { setForm({ name: '', email: '', company: '', service: '', message: '' }); setSubmitted(false); }} />
              ) : (
                <form onSubmit={handleSubmit} noValidate>
                  <div style={{ marginBottom: 36 }}>
                    <h2 style={{ fontFamily: "'Anton', sans-serif", fontWeight: 400, fontSize: 28, color: 'var(--ink)', marginBottom: 6, lineHeight: 1 }}>
                      SEND A MESSAGE
                    </h2>
                    <p style={{ fontSize: 14, color: 'var(--ink-soft)' }}>
                      Fields marked <span style={{ color: 'var(--red)', fontWeight: 700 }}>*</span> are required.
                    </p>
                  </div>

                  {/* Row 1: Name + Email */}
                  <div className="contact-form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                    <FormField
                      label="Full Name" required
                      value={form.name} onChange={handleChange('name')}
                      placeholder="Jane Doe" error={errors.name}
                    />
                    <FormField
                      label="Email Address" required type="email"
                      value={form.email} onChange={handleChange('email')}
                      placeholder="jane@company.com" error={errors.email}
                    />
                  </div>

                  {/* Row 2: Company + Service */}
                  <div className="contact-form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                    <FormField
                      label="Company / Project"
                      value={form.company} onChange={handleChange('company')}
                      placeholder="Acme Inc. or Side Project"
                    />
                    <FormSelect
                      label="Service Interest"
                      value={form.service} onChange={handleChange('service')}
                      options={SERVICES}
                    />
                  </div>

                  {/* Message */}
                  <div style={{ marginBottom: 28 }}>
                    <FormField
                      label="Your Message" required as="textarea" rows={5}
                      value={form.message} onChange={handleChange('message')}
                      placeholder="Tell us about your project — what you're building, the challenges you face, and what success looks like for you."
                      error={errors.message}
                    />
                  </div>

                  {/* Submit button */}
                  <button
                    type="submit"
                    className="hoverable"
                    disabled={sending}
                    style={{
                      display: 'inline-flex', alignItems: 'center', gap: 12,
                      padding: '16px 40px',
                      background: sending ? 'rgba(10,10,20,0.45)' : 'var(--ink)',
                      color: 'white', borderRadius: 999,
                      fontSize: 15, fontWeight: 700, 
                      boxShadow: sending ? 'none' : '0 18px 40px rgba(10,10,20,0.22)',
                      transition: 'all 220ms ease',
                      cursor: sending ? 'wait' : 'none',
                    }}
                    onMouseEnter={e => { if (!sending) { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 26px 52px rgba(10,10,20,0.3)'; } }}
                    onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = sending ? 'none' : '0 18px 40px rgba(10,10,20,0.22)'; }}
                  >
                    {sending ? (
                      <>
                        <span style={{
                          width: 16, height: 16, display: 'inline-block', borderRadius: '50%',
                          border: '2px solid rgba(255,255,255,0.3)', borderTopColor: 'white',
                          animation: 'rotateLoader 0.8s linear infinite',
                        }} />
                        Sending…
                      </>
                    ) : (
                      <>Send Message <ArrowIcon size={16} /></>
                    )}
                  </button>

                  <p style={{ marginTop: 16, fontSize: 12, color: 'var(--ink-soft)', opacity: 0.65 }}>
                    Typical response within 24 hours · trispider777@gmail.com
                  </p>
                </form>
              )}
            </div>

            {/* ── Info Sidebar ── */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

              {/* Direct contact */}
              <InfoCard>
                <CardLabel color="var(--red)">Direct Contact</CardLabel>
                <a
                  href="mailto:trispider777@gmail.com"
                  className="hoverable"
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: 10,
                    fontSize: 17, fontWeight: 700, color: 'var(--ink)',
                    transition: 'color 200ms ease',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.color = 'var(--blue)'; }}
                  onMouseLeave={e => { e.currentTarget.style.color = 'var(--ink)'; }}
                >
                  <svg width="18" height="14" viewBox="0 0 18 14" fill="none">
                    <rect x="1" y="1" width="16" height="12" rx="2" stroke="currentColor" strokeWidth="1.5" />
                    <path d="M1 4l8 5 8-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                  </svg>
                  trispider777@gmail.com
                </a>
                <p style={{ marginTop: 10, fontSize: 13, color: 'var(--ink-soft)', lineHeight: 1.65 }}>
                  For project inquiries, partnerships, press, and general questions.
                </p>
              </InfoCard>

              {/* Offices */}
              <InfoCard>
                <CardLabel color="var(--red)">Our Offices</CardLabel>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                  {OFFICES.map((o, i) => (
                    <div key={o.city}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <span style={{ fontFamily: "'Anton', sans-serif", fontWeight: 400, fontSize: 18, color: 'var(--ink)' }}>
                          {o.city.toUpperCase()}
                        </span>
                        {o.tag && (
                          <span style={{
                            fontFamily: "'Inter', sans-serif",
                            fontSize: 9, fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase',
                            color: 'var(--red)', padding: '2px 8px',
                            background: 'rgba(255,0,4,0.08)', border: '1px solid rgba(255,0,4,0.18)', borderRadius: 99,
                          }}>
                            {o.tag}
                          </span>
                        )}
                      </div>
                      {o.street && <p style={{ fontSize: 12, color: 'var(--ink-soft)', marginTop: 2 }}>{o.street}</p>}
                      <p style={{ fontSize: 12, color: 'var(--ink-soft)', marginTop: 2 }}>{o.country}</p>
                      {i < OFFICES.length - 1 && <div style={{ height: 1, background: 'var(--line)', marginTop: 14 }} />}
                    </div>
                  ))}
                </div>
              </InfoCard>

              {/* Social */}
              <InfoCard>
                <CardLabel color="var(--red)">Follow Us</CardLabel>
                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                  {SOCIALS.map(s => <SocialBtn key={s.short} {...s} />)}
                </div>
              </InfoCard>

              {/* Available badge */}
              <div
                className="reveal"
                style={{
                  background: 'linear-gradient(135deg, rgba(0,60,255,0.06), rgba(0,60,255,0.02))',
                  border: '1px solid rgba(0,60,255,0.14)',
                  borderRadius: 16, padding: '20px 24px',
                  display: 'flex', alignItems: 'center', gap: 16,
                }}
              >
                <div style={{
                  width: 10, height: 10, borderRadius: '50%', flexShrink: 0,
                  background: '#22c55e',
                  boxShadow: '0 0 0 4px rgba(34,197,94,0.2)',
                }} />
                <div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--ink)' }}>We're available</div>
                  <div style={{ fontSize: 12, color: 'var(--ink-soft)', marginTop: 2 }}>
                    Typical response time: under 24 hours
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

/* ── Sub-components ── */

function InfoCard({ children }) {
  return (
    <div
      className="reveal"
      style={{
        background: 'linear-gradient(135deg, rgba(255,255,255,0.72), rgba(255,255,255,0.38))',
        border: '1px solid var(--line)',
        borderRadius: 20, padding: 32,
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
      }}
    >
      {children}
    </div>
  );
}

function CardLabel({ children, color }) {
  return (
    <div style={{
      fontFamily: "'Inter', sans-serif",
      fontSize: 10, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase',
      color, marginBottom: 18,
    }}>
      {children}
    </div>
  );
}

function SuccessState({ name, onReset }) {
  return (
    <div style={{ textAlign: 'center', padding: '52px 24px' }}>
      <div style={{
        width: 72, height: 72, borderRadius: '50%',
        background: 'rgba(34,197,94,0.1)', border: '2px solid rgba(34,197,94,0.3)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        margin: '0 auto 28px',
      }}>
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path d="M7 16l6 6 12-12" stroke="#22c55e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      <h3 style={{ fontFamily: "'Anton', sans-serif", fontWeight: 400, fontSize: 30, color: 'var(--ink)', marginBottom: 14, lineHeight: 1 }}>
        MESSAGE SENT!
      </h3>
      <p style={{ fontSize: 15, lineHeight: 1.75, color: 'var(--ink-soft)', maxWidth: 380, margin: '0 auto 32px' }}>
        Thanks{name ? `, ${name.split(' ')[0]}` : ''}! Your email client should have opened with your message pre-filled.
        We'll reply to <strong style={{ color: 'var(--ink)' }}>trispider777@gmail.com</strong> within 24 hours.
      </p>
      <button
        onClick={onReset}
        className="hoverable"
        style={{
          fontSize: 13, fontWeight: 600, letterSpacing: 1, textTransform: 'uppercase',
          color: 'var(--blue)', padding: '11px 24px',
          border: '1px solid rgba(0,60,255,0.2)', borderRadius: 999,
          background: 'transparent', transition: 'all 200ms ease', cursor: 'none',
        }}
        onMouseEnter={e => { e.currentTarget.style.background = 'rgba(0,60,255,0.06)'; e.currentTarget.style.borderColor = 'rgba(0,60,255,0.35)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.borderColor = 'rgba(0,60,255,0.2)'; }}
      >
        Send another message
      </button>
    </div>
  );
}

function FormField({ label, required, as, rows, type = 'text', value, onChange, placeholder, error }) {
  const [focused, setFocused] = useState(false);
  const Tag = as || 'input';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
      <label style={{
        fontSize: 12, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase',
        color: error ? 'var(--red)' : 'var(--ink-soft)',
      }}>
        {label} {required && <span style={{ color: 'var(--red)' }}>*</span>}
      </label>
      <Tag
        type={type}
        rows={rows}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{
          width: '100%',
          padding: as === 'textarea' ? '13px 16px' : '13px 16px',
          fontSize: 14, fontFamily: "'Instrument Serif', serif", fontStyle: 'italic', fontWeight: 400,
          color: 'var(--ink)',
          background: focused ? 'rgba(255,255,255,0.92)' : 'rgba(255,255,255,0.55)',
          border: `1.5px solid ${error ? 'rgba(255,0,4,0.5)' : focused ? 'rgba(0,60,255,0.4)' : 'rgba(10,10,20,0.12)'}`,
          borderRadius: 12, outline: 'none',
          transition: 'all 200ms ease',
          resize: as === 'textarea' ? 'vertical' : 'none',
          lineHeight: 1.6,
          boxShadow: focused ? '0 0 0 4px rgba(0,60,255,0.07)' : error ? '0 0 0 4px rgba(255,0,4,0.06)' : 'none',
          cursor: 'text',
        }}
      />
      {error && <span style={{ fontSize: 11, color: 'var(--red)', fontWeight: 600 }}>{error}</span>}
    </div>
  );
}

function FormSelect({ label, value, onChange, options }) {
  const [focused, setFocused] = useState(false);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
      <label style={{ fontSize: 12, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', color: 'var(--ink-soft)' }}>
        {label}
      </label>
      <div style={{ position: 'relative' }}>
        <select
          value={value}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          style={{
            width: '100%', padding: '13px 40px 13px 16px',
            fontSize: 14, fontFamily: "'Instrument Serif', serif", fontStyle: 'italic', fontWeight: 400,
            color: value ? 'var(--ink)' : 'rgba(42,42,58,0.4)',
            background: focused ? 'rgba(255,255,255,0.92)' : 'rgba(255,255,255,0.55)',
            border: `1.5px solid ${focused ? 'rgba(0,60,255,0.4)' : 'rgba(10,10,20,0.12)'}`,
            borderRadius: 12, outline: 'none',
            transition: 'all 200ms ease',
            boxShadow: focused ? '0 0 0 4px rgba(0,60,255,0.07)' : 'none',
            cursor: 'none', appearance: 'none', WebkitAppearance: 'none',
          }}
        >
          <option value="">Select a service…</option>
          {options.map(o => <option key={o} value={o}>{o}</option>)}
        </select>
        <svg
          width="12" height="7" viewBox="0 0 12 7" fill="none"
          style={{ position: 'absolute', right: 16, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', opacity: 0.45 }}
        >
          <path d="M1 1l5 5 5-5" stroke="var(--ink)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    </div>
  );
}

function SocialBtn({ label, href }) {
  const [hov, setHov] = useState(false);
  return (
    <a
      href={href}
      className="hoverable"
      aria-label={label}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        width: 44, height: 44, borderRadius: 12,
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        background: hov ? 'var(--ink)' : 'rgba(255,255,255,0.6)',
        color: hov ? 'white' : 'var(--ink)',
        border: `1px solid ${hov ? 'var(--ink)' : 'var(--line)'}`,
        transition: 'all 200ms ease',
      }}
    >
      {SOCIAL_ICONS[label]}
    </a>
  );
}
